var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16.96 24.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m9.73,0c3.2,0,5.5.48,6.69.74.32.06.54.19.54.48v3.39c0,.35-.19.42-.48.42h-.1c-1.54-.06-3.94-.26-6.66-.26-2.59,0-4.19,1.25-4.19,5.44v4c0,4.42,2.02,5.44,3.58,5.44.9,0,1.7-.03,2.46-.1v-7.36c0-.35.26-.64.61-.64h4.1c.35,0,.64.29.64.64v10.75c0,.45-.16.64-.64.74-1.73.35-3.97.67-7.17.67C5.47,24.35,0,22.27,0,14.18v-3.97C0,2.05,5.09,0,9.73,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG);
export default __webpack_public_path__ + "static/media/G.07b8b57b6f5f618de0d1030db95b0d68.svg";
export { ForwardRef as ReactComponent };